// extracted by mini-css-extract-plugin
export default {"circle":"EvaluationProgress_circle__4WYBC","count":"EvaluationProgress_count__ZQGgN"};